import { SITE_CONFIG } from "../../app/config";
import { useHead, buildBreadcrumbSchema } from "../../seo";
import { curations, CURATION_CATEGORIES, getCurationsByCategory } from "./best-data";
import type { CurationCategory } from "./best-data";

const categoryIcons: Record<CurationCategory, string> = {
  "Turntables & Equipment": "🎛️",
  "Vinyl Records": "💿",
  "CD & Digital": "📀",
  "Accessories & Care": "🧹",
  "Shopping & Deals": "🛒",
};

export const BestIndex = (): JSX.Element => {
  useHead({
    title: "Best Vinyl & Music Equipment — Curated Recommendations",
    description:
      "Expert-curated lists of the best turntables, vinyl records, speakers, accessories, and more. Honest recommendations for every budget and experience level.",
    path: "/best",
    ogType: "website",
    jsonLd: buildBreadcrumbSchema([
      { name: "Home", url: "/" },
      { name: "Best Of", url: "/best" },
    ]),
  });

  return (
    <div className="shell">
      <div className="pseo-page">
        <header className="pseo-header">
          <a href="/" className="blog-back">
            ← Back to {SITE_CONFIG.name}
          </a>
          <h1 className="pseo-title">Best Of — Curated Recommendations</h1>
          <p className="pseo-subtitle">
            Honest, tested recommendations for turntables, vinyl, speakers, accessories, and more.{" "}
            <strong>{curations.length} curated lists</strong> for every budget.
          </p>
        </header>

        <div className="best-categories">
          {CURATION_CATEGORIES.map((category) => {
            const items = getCurationsByCategory(category);
            return (
              <section key={category} className="best-category-section">
                <h2 className="best-category-heading">
                  <span className="best-category-icon">{categoryIcons[category]}</span>
                  {category}
                  <span className="best-category-count">{items.length}</span>
                </h2>
                <div className="best-card-grid">
                  {items.map((curation) => (
                    <a
                      key={curation.slug}
                      href={`/best/${curation.slug}`}
                      className="best-card"
                    >
                      <h3 className="best-card-title">{curation.title}</h3>
                      <p className="best-card-desc">{curation.metaDescription}</p>
                      <span className="best-card-count">{curation.items.length} picks</span>
                      <span className="best-card-link">View recommendations →</span>
                    </a>
                  ))}
                </div>
              </section>
            );
          })}
        </div>

        <footer className="pseo-footer">
          <div className="blog-cta">
            <h3>Know What You Want? Find It Cheaper.</h3>
            <p>
              Paste your Spotify playlist and get a shopping list of vinyl & CDs at the best
              prices. Free, instant, no signup required.
            </p>
            <a href="/" className="blog-cta-button">
              Try {SITE_CONFIG.name} →
            </a>
          </div>
          <div className="pseo-nav-links">
            <a href="/guides">Guides</a>
            <a href="/glossary">Music Glossary</a>
            <a href="/compare">Compare Formats</a>
            <a href="/blog">Blog</a>
            <a href="/">Home</a>
          </div>
        </footer>
      </div>
    </div>
  );
};
